import React, {memo} from 'react';
import PropTypes from 'prop-types';
import TopHero from 'cms/helpers/TopHero';
import Section from 'helpers/Section';
import Fission from 'cms/faqs/FaqLayout/Fission';
import SearhAutosuggest from 'cms/helpers/SearhAutosuggest';
import FaqImage from 'cms/helpers/images/faqs/img_faq.png';

const FaqLayout = ({breadcrump, categories, translations, children}) => (
  <>
    <TopHero
      bgImage={FaqImage}
      breadcrump={breadcrump}
      sectionHeight="74px"
      containerClass="d-md-flex justify-content-between"
      childrenClass="py-2 w-1-1 w-md-1-3"
    >
      <SearhAutosuggest
        type="faqs"
        placeholderSearch={translations.placeholderSearch}
        notFound={translations.noResultsFound}
      />
    </TopHero>
    <Section sectionClass="pt-6 pt-md-3 bg-light-light">
      <Fission
        sidebarLabel={translations.sidebarLabel}
        moreText={translations.moreCategories}
        categories={categories}
      >
        {children}
      </Fission>
    </Section>
  </>
);

FaqLayout.propTypes = {
  breadcrump: PropTypes.array.isRequired,
  categories: PropTypes.array.isRequired,
  translations: PropTypes.shape({
    sidebarLabel: PropTypes.string.isRequired,
    placeholderSearch: PropTypes.string.isRequired,
    noResultsFound: PropTypes.string.isRequired,
    moreCategories: PropTypes.string
  }).isRequired,
  children: PropTypes.oneOfType([
    PropTypes.element,
    PropTypes.node
  ])
};

export default memo(FaqLayout);
